import React, { useState } from 'react';

import ContentfulLongText from '../../ContentfulLongText';
import { Container } from '../../Container'
import { ArrowLeft, ArrowRight } from '../../Arrow';
import './mini-slider.css';

export const MiniSlider = ({ heroContent }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % heroContent.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + heroContent.length) % heroContent.length);
    };

    return (
        <div className='mini-slider'>
            <div className="slider-content">
                {heroContent.map((item, index) => (
                    <div
                        key={index}
                        className={`relative inner-content ${index === currentIndex ? 'active' : 'inactive'}`}
                        style={{ display: index === currentIndex ? 'block' : 'none' }}
                    >
                        <Container>
                            <div className='relative text-white text-center content'>
                                <img className='absolute top-0 left-0 right-0 bottom-0' src={item.backgroundImage.gatsbyImageData.images.fallback.src} alt="Blog Page" />
                                <button onClick={prevSlide} className="slider-button prev"><ArrowLeft/></button>
                                <div className="relative flex flex-col justify-end h-full text-center details">
                                    <h1>{item.title}</h1>
                                    <ContentfulLongText longTextContent={item.content.content} />
                                    {item.buttonConfiguration && <a className='btn' href={item.buttonConfiguration.buttonLink}>{item.buttonConfiguration.buttonName}</a>}
                                </div>
                                <button onClick={nextSlide} className="slider-button next"><ArrowRight/></button>
                            </div>
                        </Container>
                    </div>
                ))}
            </div>
        </div>
    );
};